<template>
  <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12">
    <div class="card-wrap border rounded mb-4">
      <div
        class="card-wrap-header px-3 py-2 br-bottom d-flex align-items-center justify-content-between"
      >
        <!-- <div class="card-header-flex">
          <h4 class="fs-md ft-bold mb-1">Shipping Address</h4> -->
        <!-- <p class="m-0 p-0">
            <span
              class="text-success bg-light-success small ft-medium px-2 py-1"
              >Primary Account</span
            >
          </p> -->
        <!-- </div> -->
        <div class="card-head-last-flex">
          <!-- Button -->
          <!-- <a
            class="border p-3 circle text-dark d-inline-flex align-items-center justify-content-center"
            href="/dashboard/category/1/detail"
            ><i class="fas fa-pen-nib position-absolute"></i
          ></a> -->
          <!-- Button -->
          <button
            class="border bg-white text-danger p-3 circle text-dark d-inline-flex align-items-center justify-content-center"
          >
            <i class="fas fa-times position-absolute"></i>
          </button>
        </div>
      </div>
      <div class="card-wrap-body px-3 py-3">
        <img src="/assets/img/a-9.png" class="img-fluid rounded" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
